import React from "react";
import Image from "next/image";

export default function TestimonialsSection(props) {
  return <></>;
}
